export enum MainResponseStatus {
  Success = 1,
  Warning,
  Error,
}
